import './App.css';
import Navbar from './Components/Navbar';
import Card from './Components/Card';
import About from './Components/About';
import { useState } from 'react';
import Projects from './Components/Projects';
import Contactus from './Components/Contactus';

function App() {
  const [mode, setMode] = useState('light');
  const toggleMode=()=>{
    if(mode==='light')
    {
      setMode('dark');
      document.body.style.backgroundColor='black';
    }
    else{
      setMode('light');
      document.body.style.backgroundColor='white';
    }

  }
  return (
    <>
      <Navbar mode={mode} toggleMode={toggleMode}/>
      <Card mode={mode}/>
 
      
      <div data-bs-spy="scroll" data-bs-target="#navbar-example2" data-bs-offset="0" className="scrollspy-example" tabIndex="0">
        <div id="scroll2">
            <About mode={mode}/>

        </div>
        <div id="scroll3">
        <Projects mode={mode}/>

        </div>
        <div id="scroll4">
         <Contactus mode={mode}/>
           

        </div>
      </div>
    </>
  )
}

export default App;
